import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import { Formik, Form } from "formik"; // import PropTypes from 'prop-types';

import * as Yup from "yup";
import { Button, Grid, SubmitButton, Dialog, OpportunityForm, makeStyles } from "../../..";
import { Debug } from "../../../Molecules/Forms/Debug";
var opportunitySchema = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Campo obligatorio"),
  date: Yup.date()["default"](function () {
    return new Date();
  }),
  contact: Yup.string().required("Campo obligatorio"),
  type: Yup.string().required(),
  budget: Yup.number().required("Introduce un valor"),
  currency: Yup.string().required(),
  statusSells: Yup.string().required()
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    mr30: {
      "margin-right": "30px"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between"
    },
    w50: {
      width: "50%"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    }
  };
});

var DialogOpportunity = function DialogOpportunity(_ref) {
  var from = _ref.from,
      contact = _ref.contact,
      currency = _ref.currency,
      props = _objectWithoutProperties(_ref, ["from", "contact", "currency"]);

  // console.log('DialogOpportunity currency', currency)
  var initialValues = props.variant === "add" ? {
    name: "",
    date: null,
    source: "",
    contact: from === "contact-single" ? contact : "",
    type: "",
    budget: "",
    currency: currency,
    statusSells: ""
  } : props.opportunity;
  var classes = useStyles();
  var title = "";

  if (props.variant === "edit") {
    title = props.translation ? props.translation.titles.edit_opportunity : "Edit Opportunity";
  } else if (props.variant === "add") {
    title = props.translation ? props.translation.titles.add_opportunity : "Añadir Opportunity";
  }

  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "md",
    title: title,
    open: props.open,
    onClose: props.onClose,
    mode: props.variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: opportunitySchema,
    onSubmit: function onSubmit(values, _ref2) {
      var resetForm = _ref2.resetForm;

      if (props.variant === "add") {
        props.createOpportunity(values);
        resetForm = {
          name: "",
          startDate: null,
          source: "",
          contact: "",
          serviceType: "",
          estimatedValue: "",
          currency: "€",
          state: ""
        };
        props.onClose();
      } else if (props.variant === "edit") {
        props.editOpportunity(values);
        props.onClose();
      }
    },
    render: function render(_ref3) {
      var values = _ref3.values,
          setFieldValue = _ref3.setFieldValue,
          handleBlur = _ref3.handleBlur,
          isValid = _ref3.isValid,
          isSubmitting = _ref3.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "add-opportunity",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, /*#__PURE__*/React.createElement(OpportunityForm, {
        from: from,
        values: values,
        mode: props.variant,
        translation: props.translation ? props.translation : null,
        contacts: props.contacts,
        currency: currency // translation={props.translation}

      })), props.variant !== "view" && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        "data-cy": "cancel",
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, props.translation ? props.translation.buttons.cancel : "Cancel"), /*#__PURE__*/React.createElement(Button, {
        "data-cy": "submit",
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, props.variant === "add" ? props.translation ? props.translation.buttons.add : "Add" : props.translation ? props.translation.buttons.save : "Save"))));
    }
  })))];
};

export { DialogOpportunity };